module.exports = __webpack_public_path__ + "assets/icons/ic_open_in_new-be9a.svg";